// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fire-marker {
  background-size: cover;
  cursor: pointer;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgba(30, 30, 30, 0.85);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transform: translate(-50%, -50%);
  position: absolute;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.3));
}

.fire-marker:hover {
  background: rgba(50, 42, 82, 0.95);
}

/* Style for the mapboxgl-marker container */
.mapboxgl-marker {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}

.mapboxgl-popup {
  max-width: 200px;
}

.mapboxgl-popup-content {
  padding: 10px;
  border-radius: 6px;
  background: #232323;
  color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/TrendPages/Dash.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".fire-marker {\n  background-size: cover;\n  cursor: pointer;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background: rgba(30, 30, 30, 0.85);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  transform: translate(-50%, -50%);\n  position: absolute;\n  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.3));\n}\n\n.fire-marker:hover {\n  background: rgba(50, 42, 82, 0.95);\n}\n\n/* Style for the mapboxgl-marker container */\n.mapboxgl-marker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  will-change: transform;\n}\n\n.mapboxgl-popup {\n  max-width: 200px;\n}\n\n.mapboxgl-popup-content {\n  padding: 10px;\n  border-radius: 6px;\n  background: #232323;\n  color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
